import { DroneIcon, SirenIcon, WarningIcon } from "@/assets/icons/Icons";
import { Incident } from "@/types/incidents";
import { formatUserInfo } from "@/utils/formatUserInfo";
import { Checkbox } from "@/components/ui/checkbox";

interface SelectableAlertCardProps {
  alert: Incident;
  isSelected: boolean;
  onToggle: (incidentId: number) => void;
}

export const SelectableAlertCard = ({
  alert,
  isSelected,
  onToggle,
}: SelectableAlertCardProps) => {
  return (
    <button
      onClick={() => onToggle(alert.incidentID)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onToggle(alert.incidentID);
        }
      }}
      className="w-full sm:min-w-[388px] pt-4 px-4 pb-2 border-[1px] rounded-[8px] hover:bg-gray-50 dark:hover:bg-dark cursor-pointer transition-all duration-300 border-[#E3E3E3] text-left block"
    >
      <div className="flex items-center gap-4">
        {(() => {
          let bgColor = "bg-[#FF3B30]";
          let Icon = SirenIcon;

          if (alert.incidentType === "NEAR_DANGER") {
            bgColor = "bg-[#FFCC00]";
            Icon = WarningIcon;
          } else if (alert.incidentType === "DRONE_ALERT") {
            bgColor = "bg-[#26292C]";
            Icon = DroneIcon;
          }

          return (
            <div
              className={`w-[40px] h-[40px] rounded-full flex items-center justify-center ${bgColor} text-white`}
            >
              <Icon />
            </div>
          );
        })()}
        <div className="flex-1 min-w-0">
          <div className="flex justify-between items-center mb-1">
            <div className="text-body-bold truncate dark:text-gray-200">
              Case ID #{alert.incidentID}
            </div>
          </div>
          <div className="flex items-center min-w-0">
            <div className="text-overline-bold truncate overflow-hidden text-ellipsis whitespace-nowrap min-w-0 dark:text-gray-200">
              {formatUserInfo(alert.ReportedByUser)}
            </div>
            <div className="text-overline truncate ml-2 dark:text-gray-200">
              {alert.situation || (() => {
                switch (alert.incidentType) {
                  case "NEAR_DANGER": return "Near Danger";
                  case "DANGER": return "Danger";
                  case "DRONE_ALERT": return "Drone Alert";
                  default: return alert.incidentType;
                }
              })()}
            </div>
          </div>
        </div>
        <Checkbox
          checked={isSelected}
          onCheckedChange={() => onToggle(alert.incidentID)}
          className="ml-2"
        />
      </div>
    </button>
  );
};
